export const VIEW_HELP_CENTER = 'VIEW_HELP_CENTER';
export const VIEW_COMPANY_SETTINGS = 'VIEW_COMPANY_SETTINGS';
